<template>
  <div>
    <loading v-show="load"/>
    <div v-show="!load">
      <div class="row">
        <div class="col-lg-7 mb-3 mb-lg-0">
          <div class="mb-3">
            <config-regras-impressao-nova :impressoras="impressoras"/>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h6 class="mb-0 font-weight-bold">Impressoras</h6>
                <button class="btn btn-secondary btn-sm" @click="cadastrarImpressora">
                  <i class="fa fa-plus mr-1"></i> Cadastrar
                </button>
              </div>
              <div v-if="impressoras.length">
                <div v-for="(impressora, i) in impressoras" :key="impressora.id_impressora || i">
                  <div class="border-top pt-2 mt-2">
                    <div class="row align-items-center">
                      <div class="col-sm-6 col-lg-6 pointer" @click="editarImpressora(impressora)">
                        {{ impressora.descricao }}
                        <div v-if="impressora.nome_sistema" class="small text-muted">{{ impressora.nome_sistema }}</div>
                        <div class="small text-muted">Bobina {{ impressora.tamanho_bobina_mm || 80 }} mm / Fonte {{ impressora.fonte_tamanho || 13 }} px</div>
                      </div>
                      <div class="col-sm-6 col-lg-6 text-sm-right">
                        <div class="py-1 text-nowrap">
                          <button class="btn btn-primary btn-sm mr-1" style="width: 34px" @click="editarImpressora(impressora)">
                            <i class="fa fa-pencil-alt"></i>
                          </button>
                          <button class="btn btn-dark btn-sm" style="width: 34px" @click="deletarImpressora(impressora)">
                            <i class="fa fa-trash-alt"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="py-5 text-center">
                <h5 class="mb-1">Cadastrar Impressoras</h5>
                <p class="mx-auto mb-4" style="max-width: 600px">
                  Cadastre as impressoras que serão usadas no novo fluxo de impressão.
                </p>
                <button class="btn btn-secondary" @click="cadastrarImpressora">Cadastrar</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5">
          <config-sistema-nova :printers="printers" class="mb-3"/>
        </div>
      </div>
    </div>

    <modal :opened="modalImpressora" no-pad="true">
      <impressora-nova @fechar="modalImpressora = false" @salvar="buscarImpressoras"/>
    </modal>
  </div>
</template>

<script>
import Loading from "../../gestor/loading";
import Modal from "../../gestor/ModalGestor";
import ConfigRegrasImpressaoNova from "./ConfigRegrasImpressaoNova";
import ConfigSistemaNova from "./ConfigSistemaNova";
import ImpressoraNova from "./ImpressoraNova";

export default {
  name: "ConfigImpressaoNova",
  components: {
    ConfigRegrasImpressaoNova,
    ConfigSistemaNova,
    ImpressoraNova,
    Loading,
    Modal
  },

  props: {
    printers: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      load: false,
      impressoras: [],
      modalImpressora: false
    };
  },

  methods: {
    buscarImpressoras() {
      this.load = true;
      this.modalImpressora = false;

      this.$http.get('v2/impressao/impressoras')
        .then(response => {
          const body = response.data || [];
          this.impressoras = Array.isArray(body) ? body : (body.data || []);
          this.load = false;

        }, res => {
          this.load = false;
          this.$swal((res.data || {}).erro || (res.data || {}).msg || 'Erro ao buscar as impressoras');
        });
    },

    editarImpressora(impressora) {
      this.$emit('openModal', impressora);
      this.modalImpressora = true;
    },

    deletarImpressora(impressora) {
      this.$swal({
        text: "Deseja deletar esta impressora?",
        buttons: ["Cancelar", "Sim"],
        dangerMode: true
      }).then((result) => {
        if (result) {
          this.load = true;
          this.$http.post('v2/impressao/impressoras', {
            id_impressora: impressora.id_impressora,
            delete: 1
          })
            .then(res => {
              this.load = false;

              if (res.data?.success) {
                this.$swal("Impressora deletada com sucesso!");
                this.buscarImpressoras();
              }

            }, res => {
              this.load = false;
              this.$swal((res.data || {}).erro || (res.data || {}).msg || 'Erro ao deletar a impressora');
            });
        }
      });
    },

    cadastrarImpressora() {
      this.editarImpressora({
        descricao: '',
        nome_sistema: '',
        tamanho_bobina_mm: 70,
        fonte_tamanho: 13
      });
    }
  },

  created() {
    this.buscarImpressoras();
  }
}
</script>
